import * as actionTypes from '../constants/actionTypes';

const defaultState = {
    paymentHistories: [],
    subadmins: [],
    adminProjects: [],
    subadmin: {},
    objectives: [],
    audiences: [],
    loading: false,
    errors: {}
}

export const adminReducers = (state = defaultState, action = {}) => {
    switch (action.type) {
        // REDUCER FOR PAYMENT HISTORY
        case actionTypes.GET_PAYMENT_HISTORY_REQUEST:
            return {
                ...state,
                loading: true
            }
        case actionTypes.GET_PAYMENT_HISTORY_SUCCESS:
            return {
                ...state,
                loading: false,
                paymentHistories: action.payload.data.payment_history,
            }
        case actionTypes.GET_PAYMENT_HISTORY_FAIL:
            return {
                ...state,
                error: action.payload
            }
        case actionTypes.CLEAR_GET_PAYMENT_HISTORY:
            return {
                ...state,
                error: null,
                message: null
            }
        // REDUCER FOR PROJECT
        case actionTypes.GET_SUBADMIN_REQUEST:
            return {
                ...state,
                loading: true
            }
        case actionTypes.GET_SUBADMIN_SUCCESS:
            return {
                ...state,
                loading: false,
                subadmins: action.payload.data.subadmins,
            }
        case actionTypes.GET_SUBADMIN_FAIL:
            return {
                ...state,
                error: action.payload
            }
        case actionTypes.CLEAR_GET_SUBADMINS:
            return {
                ...state,
                error: null,
                message: null
            }
        // LOAD SUBADMIN
        case actionTypes.LOAD_SUBADMIN_REQUEST:
            return {
                ...state,
                loading: true
            }
        case actionTypes.LOAD_SUBADMIN_SUCCESS:
            return {
                ...state,
                loading: false,
                subadmin: action.payload.data,
            }
        case actionTypes.LOAD_SUBADMIN_FAIL:
            return {
                ...state,
                error: action.payload
            }
        
        // CREATE ACTION
        case actionTypes.CREATE_SUBADMIN_REQUEST:
            return {
                ...state,
                loading: true
            }
        case actionTypes.CREATE_SUBADMIN_SUCCESS:
            return {
                loading: false,
                message: action.payload.message,
                errors: {},
                subadmins: [...state.subadmins, action.payload.data],
            }
        case actionTypes.CREATE_SUBADMIN_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case actionTypes.CLEAR_SUBADMIN:
            return {
                ...state,
                error: null,
                message: null
            }
        // // DELETE ACTION
        case actionTypes.DELETE_SUBADMIN_REQUEST:
            return {
                ...state,
                loading: true
            }
        case actionTypes.DELETE_SUBADMIN_SUCCESS:
            return {
                ...state,
                loading: false,
                subadmins: state.subadmins.filter(item => item.id !== action.payload),
                message: action.payload.message

            }
        case actionTypes.DELETE_SUBADMIN_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload

            }
        case actionTypes.DELETE_SUBADMIN_RESET:
            return {
                ...state,
                error: null,
                message: null
            }
        // UPDATE 
        case actionTypes.UPDATE_SUBADMIN_REQUEST:
            return {
                ...state,
                loading: true
            }
        case actionTypes.UPDATE_SUBADMIN_SUCCESS:
            return {
                ...state,
                loading: false,
                subadmins: state.subadmins.map(item => item.id === action.payload.data.id ? action.payload.data : item),
                message: action.payload.message,
                status: action.payload.success
            }
        case actionTypes.UPDATE_SUBADMIN_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case actionTypes.UPDATE_SUBADMIN_RESET:
            return {
                ...state,
                error: null,
                message: null
            }
        // LOAD ADMIN DASHBOARD
        case actionTypes.GET_ADMIN_DASHBOARD_REQUEST:
            return {
                ...state,
                loading: true
            }
        case actionTypes.GET_ADMIN_DASHBOARD_SUCCESS:
            return {
                ...state,
                loading: false,
                dashboard: action.payload.data,
            }
        case actionTypes.GET_ADMIN_DASHBOARD_FAIL:
            return {
                ...state,
                error: action.payload
            }
        case actionTypes.CLEAR_GET_ADMIN_DASHBOARD:
            return {
                ...state,
                error: null,
                message: null
            }


        // ADMIN Management master data 
        case actionTypes.GET_OBJECTIVE_REQUEST:
            return {
                ...state,
                loading: true
            }
        case actionTypes.GET_OBJECTIVE_SUCCESS:
            return {
                ...state,
                loading: false,
                objectives: action.payload.data,
            }
        case actionTypes.GET_OBJECTIVE_FAIL:
            return {
                ...state,
                error: action.payload
            }
        case actionTypes.CLEAR_GET_OBJECTIVE:
            return {
                ...state,
                error: null,
                message: null
            }


        // CREATE Master Data
        case actionTypes.CREATE_OBJECTIVE_REQUEST:
            return {
                ...state,
                loading: true
            }
        case actionTypes.CREATE_OBJECTIVE_SUCCESS:
            return {
                loading: false,
                message: action.payload.message,
                errors: {},
                objectives: [...state.objectives, action.payload.data],
            }
        case actionTypes.CREATE_OBJECTIVE_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case actionTypes.CLEAR_CREATE_OBJECTIVE:
            return {
                ...state,
                error: null,
                message: null
            }
        // // DELETE Master Data
        case actionTypes.DELETE_OBJECTIVE_REQUEST:
            return {
                ...state,
                loading: true
            }
        case actionTypes.DELETE_OBJECTIVE_SUCCESS:
            return {
                ...state,
                loading: false,
                objectives: state.objectives.filter(item => item.id !== action.payload),
                message: action.payload.message

            }
        case actionTypes.DELETE_OBJECTIVE_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload

            }
        case actionTypes.DELETE_OBJECTIVE_RESET:
            return {
                ...state,
                error: null,
                message: null
            }
        // UPDATE Master Data
        case actionTypes.UPDATE_OBJECTIVE_REQUEST:
            return {
                ...state,
                loading: true
            }
        case actionTypes.UPDATE_OBJECTIVE_SUCCESS:
            return {
                ...state,
                loading: false,
                objectives: state.objectives.map(item => item.id === action.payload.data.id ? action.payload.data : item),
                message: action.payload.message,
                status: action.payload.success
            }
        case actionTypes.UPDATE_OBJECTIVE_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case actionTypes.UPDATE_OBJECTIVE_RESET:
            return {
                ...state,
                error: null,
                message: null
            }
        // Audience master data 
        case actionTypes.GET_AUDIENCE_REQUEST:
            return {
                ...state,
                loading: true
            }
        case actionTypes.GET_AUDIENCE_SUCCESS:
            return {
                ...state,
                loading: false,
                audiences: action.payload.data,
            }
        case actionTypes.GET_AUDIENCE_FAIL:
            return {
                ...state,
                error: action.payload
            }
        case actionTypes.CLEAR_GET_AUDIENCE:
            return {
                ...state,
                error: null,
                message: null
            }


        // CREATE Master Data
        case actionTypes.CREATE_HOME_PAGE_REQUEST:
            return {
                ...state,
                loading: true
            }
        case actionTypes.CREATE_HOME_PAGE_SUCCESS:
            return {
                loading: false,
                message: action.payload.message,
                errors: {},
                data: [...state.data, action.payload],
            }
        case actionTypes.CREATE_HOME_PAGE_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
            // Audience master data 
        case actionTypes.GET_HOME_PAGE_REQUEST:
            return {
                ...state,
                loading: true
            }
        case actionTypes.GET_HOME_PAGE_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload.data,
            }
        case actionTypes.GET_HOME_PAGE_FAIL:
            return {
                ...state,
                error: action.payload
            }
        
        // CREATE Master Data
        case actionTypes.CREATE_AUDIENCE_REQUEST:
            return {
                ...state,
                loading: true
            }
        case actionTypes.CREATE_AUDIENCE_SUCCESS:
            return {
                loading: false,
                message: action.payload.message,
                errors: {},
                audiences: [...state.audiences, action.payload.data],
            }
        case actionTypes.CREATE_AUDIENCE_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case actionTypes.CLEAR_CREATE_AUDIENCE:
            return {
                ...state,
                error: null,
                message: null
            }
        // // DELETE Master Data
        case actionTypes.DELETE_AUDIENCE_REQUEST:
            return {
                ...state,
                loading: true
            }
        case actionTypes.DELETE_AUDIENCE_SUCCESS:
            return {
                ...state,
                loading: false,
                audiences: state.audiences.filter(item => item.id !== action.payload),
                message: action.payload.message

            }
        case actionTypes.DELETE_AUDIENCE_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload

            }
        case actionTypes.DELETE_AUDIENCE_RESET:
            return {
                ...state,
                error: null,
                message: null
            }
        // UPDATE Master Data
        case actionTypes.UPDATE_AUDIENCE_REQUEST:
            return {
                ...state,
                loading: true
            }
        case actionTypes.UPDATE_AUDIENCE_SUCCESS:
            return {
                ...state,
                loading: false,
                audiences: state.audiences.map(item => item.id === action.payload.data.id ? action.payload.data : item),
                message: action.payload.message,
                status: action.payload.success
            }
        case actionTypes.UPDATE_AUDIENCE_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case actionTypes.UPDATE_AUDIENCE_RESET:
            return {
                ...state,
                error: null,
                message: null
            }


        // ADMIN DASHBOARD PROJECT LIST
        case actionTypes.GET_ADMIN_DASHBOARD_PROJECT_REQUEST:
            return {
                ...state,
                loading: true
            }
        case actionTypes.GET_ADMIN_DASHBOARD_PROJECT_SUCCESS:
            return {
                ...state,
                loading: false,
                adminProjects: action.payload.data.projects,
            }
        case actionTypes.GET_ADMIN_DASHBOARD_PROJECT_FAIL:
            return {
                ...state,
                error: action.payload
            }
        case actionTypes.CLEAR_GET_ADMIN_DASHBOARD_PROJECT:
            return {
                ...state,
                error: null,
                message: null
            }
        default:
            return state;
    }
}